import React, { useState } from "react";
import BlogCard from "../components/blogCard";
import "../css/blogSection.css";
import { blogPosts } from "./blogData";

const BlogSection = () => {
  const [showAll, setShowAll] = useState(false);
  const visiblePosts = showAll ? blogPosts : blogPosts.slice(0, 3);

  return (
    <div className="blog-section">
      <h1 className="section-title">Latest News & Blogs</h1>
      <div className="divider-line"></div>
      <p className="section-subtitle">
        Fresh Kimberley travel notes, local stories, and practical visitor ideas.
      </p>

      <div className="blog-grid">
        {visiblePosts.map((post, index) => (
          <BlogCard
            key={index}
            post={post}
          />
        ))}
      </div>

      {!showAll && (
        <div className="see-all-container">
          <button className="see-all-button" onClick={() => setShowAll(true)}>
            See All
          </button>
        </div>
      )}
    </div>
  );
};

export default BlogSection;
